import React from 'react';
import { Check } from 'lucide-react';
import { heroData } from '../mockData';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="relative min-h-[600px] lg:min-h-[700px] flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="Freight Logistics"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F3B]/95 via-[#0A1F3B]/80 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-[1400px] mx-auto px-6 py-16 lg:py-24">
        <div className="max-w-2xl">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {heroData.title}
          </h1>
          <p className="text-lg text-white/90 mb-4 leading-relaxed">
            {heroData.description}
          </p>
          <p className="text-base text-white/80 mb-8">
            {heroData.subtitle}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <Button className="bg-white text-[#0A1F3B] hover:bg-gray-100 px-8 py-6 text-base font-medium">
              {heroData.primaryButton}
            </Button>
            <Button 
              variant="outline" 
              className="border-2 border-white text-white hover:bg-white hover:text-[#0A1F3B] px-8 py-6 text-base font-medium bg-transparent"
            >
              {heroData.secondaryButton}
            </Button>
          </div>

          {/* Features */}
          <div className="flex flex-wrap gap-6">
            {heroData.features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 text-white">
                <Check className="w-5 h-5 text-[#00ACC1]" />
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;